import React, { useState, useEffect } from 'react';
import axios from 'axios';

const ServeIndia = () => {
    const [events, setEvents] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const [hoveredCard, setHoveredCard] = useState(null);

    // Use your live production URL base (change to localhost if testing locally)
    const API_URL = "https://lcoiapi.emedha.in/appi/serve-india";

    const fetchEvents = async () => {
        try {
            setLoading(true);
            const res = await axios.get(API_URL);
            const eventData = Array.isArray(res.data) ? res.data : res.data.rows || [];
            setEvents(eventData);
            setLoading(false);
        } catch (err) {
            console.error("Error fetching data", err);
            setError("Failed to load events. Please try again later.");
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchEvents();
    }, []);

    // Inline Styles Object
    const styles = {
        container: {
            minHeight: '100vh',
            backgroundColor: '#f8fafc',
            padding: '40px 20px',
            fontFamily: 'system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif',
        },
        wrapper: {
            maxWidth: '1200px',
            margin: '0 auto',
        },
        header: {
            textAlign: 'center',
            marginBottom: '40px',
        },
        badge: {
            display: 'inline-block',
            backgroundColor: '#dbeafe',
            color: '#1d4ed8',
            fontSize: '12px',
            fontWeight: '700',
            textTransform: 'uppercase',
            letterSpacing: '1px',
            padding: '6px 14px',
            borderRadius: '20px',
            marginBottom: '10px',
        },
        title: {
            fontSize: '32px',
            fontWeight: '800',
            color: '#0f172a',
            margin: '10px 0',
        },
        subtitle: {
            fontSize: '16px',
            color: '#475569',
            maxWidth: '600px',
            margin: '0 auto',
            lineHeight: '1.5',
        },
        loaderContainer: {
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            height: '200px',
        },
        spinner: {
            width: '40px',
            height: '40px',
            border: '4px solid #cbd5e1',
            borderTop: '4px solid #2563eb',
            borderRadius: '50%',
            animation: 'spin 1s linear infinite',
        },
        errorBox: {
            backgroundColor: '#fef2f2',
            borderLeft: '4px solid #ef4444',
            color: '#b91c1c',
            padding: '16px',
            borderRadius: '8px',
            textAlign: 'center',
            maxWidth: '500px',
            margin: '0 auto',
        },
        emptyBox: {
            textAlign: 'center',
            color: '#64748b',
            padding: '40px',
            fontSize: '16px',
        },
        grid: {
            display: 'grid',
            gridTemplateColumns: 'repeat(auto-fit, minmax(320px, 1fr))',
            gap: '24px',
        },
        card: (isHovered) => ({
            backgroundColor: '#ffffff',
            borderRadius: '16px',
            overflow: 'hidden',
            boxShadow: isHovered
                ? '0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04)'
                : '0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06)',
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'space-between',
            transition: 'transform 0.3s ease, box-shadow 0.3s ease',
            transform: isHovered ? 'translateY(-6px)' : 'translateY(0)',
            border: '1px solid #e2e8f0',
        }),
        cardHeader: {
            background: 'linear-gradient(135deg, #1e40af, #3b82f6)',
            padding: '18px 24px',
            color: '#ffffff',
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
        },
        categoryBadge: {
            backgroundColor: 'rgba(255, 255, 255, 0.2)',
            fontSize: '11px',
            fontWeight: '700',
            textTransform: 'uppercase',
            padding: '4px 10px',
            borderRadius: '6px',
            letterSpacing: '0.5px',
        },
        dateText: {
            fontSize: '13px',
            fontWeight: '600',
            color: '#eff6ff',
        },
        cardBody: {
            padding: '24px',
        },
        cardTitle: {
            fontSize: '20px',
            fontWeight: '700',
            color: '#1e293b',
            marginBottom: '12px',
            lineHeight: '1.4',
        },
        venueBox: {
            display: 'flex',
            alignItems: 'center',
            fontSize: '14px',
            color: '#64748b',
            marginBottom: '16px',
            fontWeight: '500',
        },
        description: {
            fontSize: '14px',
            color: '#475569',
            lineHeight: '1.6',
            display: '-webkit-box',
            WebkitLineClamp: '4',
            WebkitBoxOrient: 'vertical',
            overflow: 'hidden',
        },
    };

    return (
        <div style={styles.container}>
            <div style={styles.wrapper}>

                {/* Header Section */}
                <div style={styles.header}>
                    <span style={styles.badge}>Flagship Initiative</span>
                    <h1 style={styles.title}>We Serve India Events</h1>
                    <p style={styles.subtitle}>
                        Recognizing changemakers and leaders building lasting connections and strengthening our world.
                    </p>
                    <p style={styles.subtitle}>
                        We Serve India – Season 3 is a flagship social impact initiative by Forbes India, in association with CNN-News18 and Lions Clubs International, recognising individuals and organisations creating meaningful impact across India. This season, changemakers will be recognised across four categories — Education & Skills Transformation, Healthcare & Accessibility, Environmental Sustainability & Climate Resilience, and Community Resilience & Disaster Relief",
                    </p>
                </div>

                {/* Loading State */}
                {loading && (
                    <div style={styles.loaderContainer}>
                        <div style={styles.spinner}></div>
                    </div>
                )}

                {/* Error State */}
                {error && (
                    <div style={styles.errorBox}>
                        {error}
                    </div>
                )}

                {/* Empty State */}
                {!loading && !error && events.length === 0 && (
                    <div style={styles.emptyBox}>
                        No events found at this moment.
                    </div>
                )}

                {/* Responsive Events Grid */}
                {!loading && !error && events.length > 0 && (
                    <div style={styles.grid}>
                        {events.map((event) => {
                            const isHovered = hoveredCard === event.id;
                            return (
                                <div
                                    key={event.id}
                                    style={styles.card(isHovered)}
                                    onMouseEnter={() => setHoveredCard(event.id)}
                                    onMouseLeave={() => setHoveredCard(null)}
                                >
                                    <div>
                                        {/* Card Gradient Header */}
                                        <div style={styles.cardHeader}>
                                            <span style={styles.categoryBadge}>
                                                {event.category || "Event"}
                                            </span>
                                            <span style={styles.dateText}>
                                                📅 {event.event_date}
                                            </span>
                                        </div>

                                        {/* Card Content */}
                                        <div style={styles.cardBody}>
                                            <h2 style={styles.cardTitle}>
                                                {event.title}
                                            </h2>

                                            <div style={styles.venueBox}>
                                                <span style={{ marginRight: '6px' }}>📍</span>
                                                <span>{event.venue}</span>
                                            </div>

                                            <p style={styles.description}>
                                                {event.description}
                                            </p>
                                        </div>
                                    </div>
                                </div>
                            );
                        })}
                    </div>
                )}

            </div>
        </div>
    );
};

export default ServeIndia;